import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@/shared/ui/IconButton';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/ui/DropdownMenu';
import { usePrefsStore } from '@/entities/preferences/model/prefsStore';
import { LANGUAGE_LABELS, SUPPORTED_LANGUAGES } from '@/shared/i18n';

export function LanguageMenu() {
  const { t } = useTranslation();
  const language = usePrefsStore((s) => s.prefs.language);
  const setPrefs = usePrefsStore((s) => s.set);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton label={t('prefs.language.label')}>
          <Languages className="h-4 w-4" />
        </IconButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SUPPORTED_LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l}
            onSelect={() => setPrefs({ language: l })}
            className={l === language ? 'text-brand-600 font-semibold' : ''}
          >
            {LANGUAGE_LABELS[l]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
